/*
 * Cart store confirm page: terms agreement + double-submit prevention.
 */

function initCartStoreConfirm() {
  const form = document.getElementById('cart-store-confirm-form');
  const submitBtn = document.getElementById('submit-btn');
  const agreeTermsPc = document.getElementById('agree-terms');
  const agreeTermsSp = document.getElementById('agree-terms--sp');
  const spinner = document.getElementById('cart-store-confirm-spinner');

  if (!form || !submitBtn) {
    return;
  }

  const updateSubmitState = () => {
    const agreed = Boolean(agreeTermsPc?.checked || agreeTermsSp?.checked);
    submitBtn.disabled = !agreed || form.dataset.submitting === 'true';
  };

  if (agreeTermsPc && agreeTermsSp) {
    agreeTermsPc.addEventListener('change', () => {
      agreeTermsSp.checked = agreeTermsPc.checked;
      updateSubmitState();
    });
    agreeTermsSp.addEventListener('change', () => {
      agreeTermsPc.checked = agreeTermsSp.checked;
      updateSubmitState();
    });
  }

  form.addEventListener('submit', (e) => {
    if (form.dataset.submitting === 'true') {
      e.preventDefault();
      return;
    }

    if (submitBtn.disabled) {
      e.preventDefault();
      return;
    }

    form.dataset.submitting = 'true';
    submitBtn.disabled = true;
    if (spinner) {
      spinner.style.display = 'block';
    }
  });

  updateSubmitState();
}

document.addEventListener('DOMContentLoaded', initCartStoreConfirm);
